import React from 'react';

import { observer } from 'mobx-react';

import classes from './BodyMetricsWidget.module.scss';
import { scanIqCustomerProfileStore } from '../../../../../../stores/scanIqCustomerProfileStore';
import { InfoBox } from '../../../../../../../shared/components/ui-components';
import { InfoBlock } from './InfoBlock/InfoBlock';
import { calculateFullYears } from '../../../../../../../shared/utils/dateUtils';
import { getFeetInchesFromInches } from '../../../../../../../shared/utils/mathUtils/getFeetInchesFromInches/getFeetInchesFromInches';

const BodyMetricsWidget = observer(() => {
  const { customerProfileInfo } = scanIqCustomerProfileStore;

  if (!customerProfileInfo) {
    return null;
  }

  const { personalData, bodyMetrics } = customerProfileInfo;

  const renderBodyMetricsValue = () => {
    if (!bodyMetrics.bmr) {
      return '-';
    }

    return (
      <>
        {bodyMetrics.bmr} <span className={classes.bmrUnit}>kcal / day</span>
      </>
    );
  };

  return (
    <InfoBox title="Body Metrics" customMargin>
      <div className={classes.container}>
        <InfoBlock title="Basal Metabolic Rate (BMR)" value={renderBodyMetricsValue()} />
        <InfoBlock title="Gender" value={personalData.gender} />
        <InfoBlock title="Age" value={calculateFullYears(personalData.dateOfBirth)} />
        <InfoBlock
          title="Height"
          value={getFeetInchesFromInches(personalData.height).value}
        />
        <InfoBlock title="Weight" value={bodyMetrics.weight || '-'} />
      </div>
    </InfoBox>
  );
});

export { BodyMetricsWidget };
